export const breakoutStyle = (template) => {
  if (template && template.interaction.breakouts) {
    const obj = template.interaction.breakouts;

    const frame = obj.frame;
    const title = obj.title;
    const subtitle = obj.subtitle;
    const list = obj.list;
    const listItem = obj.listItem;
    const button = obj.listItem.button;
    const avatar = obj.listItem.avatar;
    const text = obj.listItem.text;
    const readMore = obj.readMore;
    const description = obj.description;
    const rowDivider = obj.rowDivider;

    return {
      frame: {
        borderColor: frame.borderColor != "unset" ? frame.borderColor : "unset",
        borderWidth: frame.borderWidth != "unset" ? frame.borderWidth : "0px",
        background: frame.background != "unset" ? frame.background : "#fff",
        borderRadius: frame.borderRadius != "unset" ? frame.borderRadius : "0px",
        boxShadow: "none",
        borderStyle: "solid",
      },
      title: {
        fontSize: title.fontSize != "unset" ? title.fontSize : "23px",
        color: title.color != "unset" ? title.color : "#222",
        fontWeight: title.fontWeight != "unset" ? title.fontWeight : "bold",
        fontFamily: title.fontFamily != "unset" ? title.fontFamily : "Open Sans",
      },
      subtitle: {
        fontSize: subtitle.fontSize != "unset" ? subtitle.fontSize : "18px",
        color: subtitle.color != "unset" ? subtitle.color : "#222",
        fontWeight: subtitle.fontWeight != "unset" ? subtitle.fontWeight : "normal",
        fontFamily: subtitle.fontFamily != "unset" ? subtitle.fontFamily : "Open Sans",
      },
      description: {
        fontSize: description.fontSize != "unset" ? description.fontSize : "18px",
        color: description.color != "unset" ? description.color : "#222",
        fontWeight: description.fontWeight != "unset" ? description.fontWeight : "normal",
        fontFamily: description.fontFamily != "unset" ? description.fontFamily : "Open Sans",
      },
      rowDivider: {
        backgroundColor: rowDivider.backgroundColor != "unset" ? rowDivider.backgroundColor : "#000",
        height: rowDivider.height != "unset" ? rowDivider.height : "0px",
      },
      readMore: {
        fontSize: readMore.fontSize != "unset" ? readMore.fontSize : "18px",
        color: readMore.color != "unset" ? readMore.color : "#222",
        fontWeight: readMore.fontWeight != "unset" ? readMore.fontWeight : "normal",
        fontFamily: readMore.fontFamily != "unset" ? readMore.fontFamily : "Open Sans",
      },
      list: {
        marginLeft: list.marginLeft != "unset" ? list.marginLeft : "0px",
        marginRight: list.marginRight != "unset" ? list.marginRight : "0px",
        width: list.width != "unset" ? list.width : "100%",
      },
      listItem: {
        background: listItem.background != "unset" ? listItem.background : "#fff",
        marginLeft: listItem.marginLeft != "unset" ? listItem.marginLeft : "0px",
        marginRight: listItem.marginRight != "unset" ? listItem.marginRight : "0px",
        borderRadius: listItem.borderRadius != "unset" ? listItem.borderRadius : "0px",
        boxShadow: "none",
        width: listItem.width != "unset" ? listItem.width : "100%",
        borderStyle: "solid",
        borderWidth: listItem.borderWidth != "unset" ? listItem.borderWidth : "0px",
        borderColor: listItem.borderColor != "unset" ? listItem.borderColor : "unset",
        border: 0,
        borderBottom: `${listItem.borderWidth} solid ${listItem.borderColor}`,
        /*    width: listItem.width != "unset" ? listItem.width : "100%", */
        text: {
          fontSize: text.fontSize != "unset" ? text.fontSize : "15px",
          color: text.color != "unset" ? text.color : "#222",
          fontWeight: text.fontWeight != "unset" ? text.fontWeight : "normal",
          fontFamily: text.fontFamily != "unset" ? text.fontFamily : "Open Sans",
        },
        button: {
          color: button.color != "unset" ? button.color : "#5a60e3",
          background: "unset",
          fontSize: button.fontSize != "unset" ? button.fontSize : "15px",
        },
        avatar: {
          color: avatar.color != "unset" ? avatar.color : "#fff",
          background: avatar.background != "unset" ? avatar.background : "rgb(216 218 253)",
          activeColor: avatar.activeColor != "unset" ? avatar.activeColor : "#fff",
          activeBackground: avatar.activeBackground != "unset" ? avatar.activeBackground : "#5a60e3",
        },
      },
    };
  }
};
